import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import RecCardContent from "@/common/components/RecCardContent.vue";
import RecCardFooter from "@/common/components/RecCardFooter.vue";
import RecCardTitle from "@/common/components/RecCardTitle.vue";
import RecDialog from "@/common/components/RecDialog.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeleteConfirmationDialog',
    props: {
        "modelValue": { type: Boolean },
        "modelModifiers": {},
    },
    emits: /*@__PURE__*/ _mergeModels(["confirm", "cancel"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        // Components
        const visible = _useModel(__props, "modelValue");
        const emit = __emit;
        const onCancel = () => {
            if (!visible.value)
                return;
            visible.value = false;
            emit("cancel");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(RecDialog, {
                modelValue: visible.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((visible).value = $event)),
                size: "medium",
                "close-on-click-outside": "",
                onHide: onCancel
            }, {
                default: _withCtx(() => [
                    _createVNode(RecCardTitle, null, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("Delete File")), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(RecCardContent, null, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("Deleting this file will remove all its data from the Study.")) + " " + _toDisplayString(_ctx.$t("This action cannot be undone.")) + " " + _toDisplayString(_ctx.$t("Are you sure you want to continue?")), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(RecCardFooter, { class: "justify-end" }, {
                        default: _withCtx(() => [
                            _createElementVNode("button", {
                                class: "btn",
                                onClick: onCancel
                            }, _toDisplayString(_ctx.$t("Cancel")), 1),
                            _createElementVNode("button", {
                                class: "btn btn-danger",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('confirm')))
                            }, _toDisplayString(_ctx.$t("Delete")), 1)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
